import styles from "./Settings.module.scss";
import React from "react";
import clsx from "clsx";
import {NavLink, Outlet} from "react-router";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {rxToggleMobileMenu, settingsSelector} from "../../slices/settingsSlice";

const Settings = () => {
  return (
    <div className={clsx(styles.settings)}>
      <SettingsMenu/>

      <div className={styles.settingsContent}>
        <Outlet/>
      </div>
    </div>
  );
};

const SettingsNavLink = ({to, icon, label, ...otherProps}) => {
  const {t} = useTranslation("settings");

  return <NavLink
    to={to}
    className={({isActive}) => clsx(styles.menuEntry, isActive ? styles.active : null)}
    {...otherProps}
  >
    <span className={styles.menuIcon}><span className="material-icons">{icon}</span></span>
    <span className={styles.menuName}>{t(label)}</span>
  </NavLink>;
};

export const SettingsMenu = () => {
  const dispatch = useDispatch();

  const closeMenu = () => dispatch(rxToggleMobileMenu(false));

  return <div className={styles.settingsMenu}>
    <SettingsNavLink to="/settings"
                     icon="settings"
                     label="menu_general"
                     end
                     onClick={closeMenu}/>
    <SettingsNavLink to="/settings/transactions"
                     icon="account_balance"
                     label="menu_transactions"
                     onClick={closeMenu}/>
    <SettingsNavLink to="/settings/portfolio"
                     icon="trending_up"
                     label="menu_portfolio"
                     onClick={closeMenu}/>
    <SettingsNavLink to="/settings/cars"
                     icon="local_gas_station"
                     label="menu_cars"
                     onClick={closeMenu}/>
    <SettingsNavLink to="/settings/transactions-categories"
                     icon="category"
                     label="menu_transactions_categories"
                     onClick={closeMenu}/>
    <SettingsNavLink to="/settings/transactions-rules"
                     icon="alt_route"
                     label="menu_transactions_rules"
                     onClick={closeMenu}/>
    <SettingsNavLink to="/settings/tags"
                     icon="label"
                     label="menu_tags"
                     onClick={closeMenu}/>
    <SettingsNavLink to="/settings/authentication"
                     icon="account_circle"
                     label="menu_account_authentication"
                     onClick={closeMenu}/>
    {/*<SettingsNavLink to="/settings/subscription"
                     icon="card_membership"
                     label="menu_account_subscription"
                     onClick={closeMenu}/>*/}
  </div>;
};

export const SettingsMenuMobile = () => {
  const settings = useSelector(settingsSelector);

  return <div className={clsx(styles.settingsMenuMobile, settings.mobileMenuShown ? styles.shown : null)}>
    <SettingsMenu/>
  </div>;
};

export default Settings;
